import { render, staticRenderFns } from "./sablonverigirisi.vue?vue&type=template&id=11a52883&"
import script from "./sablonverigirisi.vue?vue&type=script&lang=js&"
export * from "./sablonverigirisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports